import Datalayer from './datalayer'

const datalayer = new Datalayer()
datalayer.init()
